import { gsap } from "gsap";

export default class SubMenu {
	constructor(elm, menu) {

        // Parent Class
        this.menu = menu;

        // Media Queries
        this.mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.largeDesktop = window.matchMedia('(min-width:1200px)');

		// DOM elements
		this.elm = elm;

        this.parentLink = this.elm.querySelector(":scope > a");
        this.submenuWrapper = this.parentLink.closest('li').querySelector('.sub-menu-wrapper');
        this.submenu = this.submenuWrapper.querySelector('.sub-menu');


        this.links = this.submenu.querySelectorAll('a');
        this.links.forEach(link => {
            link.setAttribute('tabindex', '-1');
        });

		// Status
		this.detailsOpen = false;

        this.parentLink.addEventListener('click', evt => {
            if(!this.largeDesktop.matches) {
                this.toggleDetails(evt);
            }
        });

	}

	/**
	 * @param {boolean} value
	 */
	set open(value) {
		this.detailsOpen = value;

		if (value) {
			this.submenu.classList.add('is-open');
		} else {
			this.submenu.classList.remove('is-open');
		}

	}

	set opening(value) {
		if (value) {
			this.submenu.classList.add('is-opening');
		} else {
			this.submenu.classList.remove('is-opening');
		}
	}

	get open() {
		return this.detailsOpen;
	}

	toggleDetails(evt) {
		if(this.menu.animating) {
            evt.preventDefault();
            evt.stopPropagation();
			return;
		}

		if (this.open) {
			//this.closeDetails();
		} else {
            evt.preventDefault();
            evt.stopPropagation();
			this.openDetails();

            this.menu.submenus.forEach(elm => {
                if(elm.open) {
                    elm.closeDetails();
                }
            });
		}
	}

	openDetails() {

        const tl = gsap.timeline({
            onStart: () => {
                this.menu.animating = true;
		        this.opening = true;

            },
            onComplete: () => {
                this.menu.animating = false;
                this.open = true;
            }
        });

        tl.fromTo(this.submenuWrapper, {
            height: 0
        }, {
            height: this.submenu.scrollHeight+'px',
            ease: 'power2.inOut',
            duration: 0.6,
        });

        tl.fromTo(this.submenuWrapper, {
            opacity: 0
        }, {
            opacity: 1,
            ease: 'none',
            duration: 0.4,
        });
	}

	closeDetails() {

        const tl = gsap.timeline({
            onStart: () => {
                this.menu.animating = true;
		        this.opening = false;
            },
            onComplete: () => {
                this.menu.animating = false;
			    this.open = false;
            }
        });

        tl.fromTo(this.submenuWrapper, {
            opacity: 1
        }, {
            opacity: 0,
            ease: 'none',
            duration: 0.2,
        });

        tl.fromTo(this.submenuWrapper, {
            height: this.submenu.scrollHeight+'px'
        }, {
            height: 0,
            ease: 'power2.inOut',
            duration: 0.6,
        }, 0);
	}
}